export const SITE = {
  name: "TubeOptimizer LLC",
  email: "contact@tubeoptimizer.net",
  state: "Wyoming",
  address: ["TubeOptimizer LLC", "30 N Gould St Ste R", "Sheridan, WY 82801", "United States"],
};
